class AnalyticsService {
  constructor(providers) {
    this.providers = providers;
    this.enableProviders = []
  }

  initialize() {
    try {
      this.providers.forEach(provider => {
        const isInitialize = provider.initialize();
        if (isInitialize)
          this.enableProviders.push(provider);
      });
    } catch (error) {
      console.error("Analytics Init Error:", error);
    }
  }

  track(eventPayload) {
    this.enableProviders.forEach(provider => {
      const payload = eventPayload?.[provider.name]
      payload && provider?.track?.(payload);
      return
    });
  }

  pageView(eventPayload) {
    this.enableProviders.forEach(provider => {
      const payload = eventPayload?.[provider.name]
      provider?.pageView?.(payload);
    });
  }
}

export default AnalyticsService;